import { render, staticRenderFns } from "./CarCategoryDropdown.vue?vue&type=template&id=573e89c8&scoped=true&"
import script from "./CarCategoryDropdown.vue?vue&type=script&lang=js&"
export * from "./CarCategoryDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573e89c8",
  null
  
)

export default component.exports